import React from 'react';
import capitalize from 'lodash/capitalize';

import {
  CheckIcon,
  CircleSlashIcon,
  HourglassIcon,
  QuestionIcon,
} from '@primer/octicons-react';

import { IconBadge } from '../../common/Badge/Badge';

const mapStatusToIcon = (status) => {
  if (status === 'Started' || status === 'Running') {
    return HourglassIcon;
  }
  if (status === 'Success') {
    return CheckIcon;
  }
  if (status === 'Failure') {
    return CircleSlashIcon;
  }

  return QuestionIcon;
}

const COLOR_MAP = {
  Started: 'bg-blue-500',
  Running: 'bg-blue-500',
  Success: 'bg-green-500',
  Failure: 'bg-gray-500',
  Unknown: 'bg-gray-500',
}

export const TaskStatusBadge = ({ status, textColor = 'text-white' }) => {
  const capitalizedStatus = capitalize(status);
  return (
    <IconBadge
      className="p-2 w-28"
      bgColor={COLOR_MAP[capitalizedStatus]}
      icon={mapStatusToIcon(capitalizedStatus)}
      textColor={textColor}
    >
      {capitalizedStatus}
    </IconBadge>
  )
}

export default TaskStatusBadge;
